<template>
    <DefaultHeader />
    <div :class="{ 'd-none': this.$store.state.hiddenBody }" class="container-fluid">
        <div class="row d-flex justify-content-center">
            <div class="col-11 mb-3 mb-lg-5">
                <div class="card table-nowrap table-card">
                    <div class="table-responsive">
                        <table class="table mb-0 table-striped">
                            <thead class="small text-uppercase bg-body text-muted">
                                <tr class="align-middle">
                                    <td>
                                        <div class="form-group">
                                            <input v-model="name" type="text" class="form-control" autocomplete="off"
                                                aria-describedby="emailHelp" placeholder="Nom">
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group">
                                            <select v-model="type" class="form-select">
                                                <option value="MOBILE">Mobile (textos)</option>
                                                <option value="EMAIL">E-mail</option>
                                            </select>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group">
                                            <input v-model="contact" type="text" class="form-control"
                                                placeholder="Donées de contact (numéro +336872... ou e-mail)">
                                        </div>
                                    </td>
                                    <td class="text-end">
                                        <button class="btn btn-primary btn-block"
                                            @click="createContact()"><font-awesome-icon :icon="['fas', 'circle-plus']" />
                                            Ajouter contact</button>
                                    </td>
                                </tr>
                            </thead>
                            <tbody class="small text-uppercase bg-body text-muted">
                                <tr>
                                    <th class="align-middle">Nom</th>
                                    <th class="align-middle">Type</th>
                                    <th class="align-middle">Contact</th>
                                    <th class="align-middle"></th>
                                </tr>
                                <TableRow v-for="contact in contacts"
                                :key="contact.id"
                                :contact="contact"
                                :profiles="profiles"
                                @delete="deleteContact">
                                </TableRow>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <DefaultFooter />
</template>
    
<script>
import DefaultHeader from '@/components/DefaultHeader.vue'
import DefaultFooter from '@/components/DefaultFooter.vue'
import ContactService from '@/services/contact.service.js'
import FormatHelper from '@/helpers/format.helper.js'
import TableRow from './Sections/TableRow.vue'

export default {
    components: {
        DefaultHeader,
        DefaultFooter,
        TableRow,
    },
    data() {
        return {
            contacts: null
        };
    },
    mounted() {
        this.refreshData();
    },
    methods: {
        refreshData() {
            ContactService.getList()
            .then(response => {
                this.contacts = FormatHelper.contactsResponseFormat(response.data);
            })
            .catch(e => {
                console.log(e);
            });
        },
        createContact() {
            if(!this.name || !this.type || !this.contact) {
                return;
            }
            ContactService.create(this.name, this.type, this.contact)
            .then(() => {
                this.refreshData();
                this.name = null;
                this.type = null;
                this.contact = null;
            })
            .catch(e => {
                console.log(e);
            });
        },
        deleteContact(data) {
            ContactService.delete(data)
            .then(() => {
                this.refreshData();
            })
            .catch(e => {
                console.log(e);
            });
        },
    }
}
</script>